import { Division, DIVISIONS_LIST } from "src/app/core/interfaces/division";
import { ICompositionItem, IDivision } from "src/app/core/interfaces/project-entity";

export type ModuleDivisionState = Pick<ICompositionItem, "active"> & { config: { division: IDivision } };

const isDivisionActive = (module: ModuleDivisionState | undefined, division: Division): boolean =>
  !!module?.active && !!module.config?.division?.[division];

/**
 * Returns the divisions that went from inactive to active between two states of one module.
 * A division counts as active only while the module itself is active.
 */
export const getActivatedDivisions = (
  previous: ModuleDivisionState | undefined,
  next: ModuleDivisionState | undefined
): Array<Division> =>
  DIVISIONS_LIST.filter((division) => !isDivisionActive(previous, division) && isDivisionActive(next, division));
